import React, { Suspense } from "react"
import { useRouter } from "next/router"
import { Form } from "app/core/components/Form"
import SearchField from "app/core/components/SearchField"

type SearchTestsProp = {
  resetPage?: boolean
}

export const SearchTests: React.FC<SearchTestsProp> = ({ resetPage = true }) => {
  const router = useRouter()
  const query = router.query as { search?: string; page: string }

  const initialSearch = (query.search as string) || ""

  return (
    <Form
      initialValues={{ search: initialSearch }}
      onSubmit={async (values) => {
        const newQuery = { ...(resetPage ? { page: 1 } : {}), ...query }
        if (values.search) {
          router.push({ query: { search: values.search } })
        } else {
          router.push({ query: {} })
        }
      }}
    >
      <div className="max-w-xs"></div>
      <SearchField name="search" placeholder="Search" className="w-med text-med px-4 py-1" />
    </Form>
  )
}
